/**
 * Home Route (Index)
 * Main dashboard page - requires authentication
 */

import { createFileRoute, redirect } from '@tanstack/react-router';
import { requireAuth } from '../router/guards';

// Create index route that redirects to /home
export const Route = createFileRoute('/')({
  beforeLoad: async () => {
    await requireAuth();
    throw redirect({ to: '/home' });
  },
});
